import { useGlobalNotification } from "src/hooks/useGlobalNotification";

function GlobalNotification() {
  let { list } = useGlobalNotification();

  // console.log(list, "GlobalNotification");
}

export { GlobalNotification };
